var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table-wrap" }, [
    _c("table", { staticClass: "app-table" }, [
      _vm._m(0),
      _c(
        "tbody",
        [
          _vm.loading
            ? _c("tr", [
                _c(
                  "td",
                  { staticClass: "state-cell", attrs: { colspan: "6" } },
                  [_c("Spinner", { attrs: { size: "small" } })],
                  1
                ),
              ])
            : !_vm.apps.length
            ? _c("tr", [
                _c(
                  "td",
                  { staticClass: "state-cell", attrs: { colspan: "6" } },
                  [_vm._v("No apps available")]
                ),
              ])
            : _vm._l(_vm.apps, function (app) {
                return _c(
                  "tr",
                  {
                    key: app.app_id,
                    class: _vm.rowClass(app),
                    on: {
                      click: function ($event) {
                        return _vm.handleSelect(app)
                      },
                    },
                  },
                  [
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass: "c-radio",
                          class: { checked: _vm.selectedAppId === app.app_id },
                        },
                        [_c("div", { staticClass: "c-dot" })]
                      ),
                    ]),
                    _c("td", [
                      _c("div", { staticClass: "td-name" }, [
                        _vm._v(_vm._s(app.app_name)),
                      ]),
                    ]),
                    _c("td", [
                      _c("div", { staticClass: "td-id" }, [
                        _vm._v(_vm._s(app.app_id)),
                      ]),
                    ]),
                    _c("td", [
                      _c("div", { staticClass: "td-muted" }, [
                        _vm._v(_vm._s(_vm.getRegionName(app.region))),
                      ]),
                    ]),
                    _c("td", [
                      _c("div", { staticClass: "td-muted td-date" }, [
                        _vm._v(_vm._s(app.create_time)),
                      ]),
                    ]),
                    _c(
                      "td",
                      [
                        _c("app-status-badge", {
                          attrs: { enabled: app.status !== 0 },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _c("th", [_vm._v("App Name")]),
        _c("th", [_vm._v("App ID")]),
        _c("th", [_vm._v("Country / Region")]),
        _c("th", [_vm._v("Created")]),
        _c("th", [_vm._v("Status")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }